import React from "react";
import lightningCloud from "assets/images/lightning-cloud.svg";
import { P } from "common/components/Paragraph";

interface EmptyProps {
  title: string;
  description?: string;
  children?: React.ReactNode;
}

export const Empty: React.FC<EmptyProps> = ({ title, description, children }) => {
  let imgPath = lightningCloud as string;
  if (!imgPath.startsWith("/")) {
    imgPath = `/${lightningCloud}`;
  }

  return (
    <div className="text-center">
      <div className="w-full flex items-center justify-center mb-xl">
        <img className="h-[250px] w-[300px]" src={imgPath} alt="" />
      </div>
      <h4 className="mb-sm">{title}</h4>
      {description && <P className="text-secondary-500 mb-sm">{description}</P>}
      <div className="flex justify-center items-center">{children}</div>
    </div>
  );
};
